<template>
  <TemplateView>
    <transition name="fade" mode="out-in" appear>
      <LoadingAnimation v-if="loadingAnimation" :key="'loadingAnimation' + loadingAnimation" />
    </transition>
    <div
      class="wrapper_table_work"
      v-show="
        workClientProjectPeriods &&
        workClientProjectPeriods.data &&
        workClientProjectPeriods.data.length &&
        !loadingAnimation
      "
      :key="'wrapper_table_work'"
    >
      <div class="container">
        <div class="checkbox_grid">
          <v-checkbox v-model="employeesShow" class="checkbox" hide-details>
            <template slot="label">
              <BaseIcon class="icon icon--employee" icon="pages-hr" />
              {{ this.localStorage.translations.pages.personnel_department.pages.sotrudniki }}
            </template>
          </v-checkbox>
          <v-checkbox v-model="periodsShow" class="checkbox" hide-details>
            <template slot="label">
              <BaseIcon class="icon icon--works" icon="pages-settings-work_types" />
              {{ this.localStorage.translations.pages.setting.pages['vidy-rabot'] }}
            </template>
          </v-checkbox>
          <v-checkbox
            v-for="(item, index) in filterList"
            :key="index"
            v-model="filter"
            :value="item.value"
            class="checkbox"
            hide-details
          >
            <template slot="label">
              <IconPlanning :name="item.value" width="17" height="17" class="mr-1" />
              {{ item.text }}
            </template>
          </v-checkbox>
        </div>
      </div>

      <div class="pdf_wrapper" id="target">
        <PlanningGeneralScheduleGantt ref="gantt" :tasks="tasks" />
      </div>
    </div>
    <transition name="fade" mode="out-in" appear>
      <Plug
        v-if="
          (!workClientProjectPeriods && !loadingAnimation) ||
          (workClientProjectPeriods &&
            workClientProjectPeriods.data &&
            !workClientProjectPeriods.data.length)
        "
        key="Plug"
      />
    </transition>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PlanningGeneralScheduleGantt from 'components/planning/PlanningGeneralScheduleGantt'
import TemplateView from 'components/templates/TemplateView'
import Plug from 'components/Plug'
import LoadingAnimation from 'components/LoadingAnimation'
import IconPlanning from 'components/icons/planning/IconPlanning'
export default {
  name: 'planningGeneralSchedule',
  components: {
    PlanningGeneralScheduleGantt,
    TemplateView,
    Plug,
    LoadingAnimation,
    IconPlanning,
  },
  data() {
    return {
      tasks: {
        data: [],
        links: [],
      },
      workType: [],
      workArr: [],
      filter: ['in_progress'],
      order: 'name:asc',
      createPdf: false,
      employeesShow: true,
      periodsShow: false,
    }
  },
  computed: {
    ...mapGetters('workClientProject', ['workClientProjectPeriods']),
    ...mapGetters(['loadingAnimation']),
    filterList() {
      return [
        {
          text: this.localStorage.translations.pages.projects_status.status['predvaritelnyy'] || '',
          value: 'creating',
        },
        {
          text: this.localStorage.translations.pages.projects_status.status['beginer'] || '',
          value: 'intro',
        },
        {
          text:
            this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'] || '',
          value: 'bidding',
        },
        {
          text:
            this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya'] || '',
          value: 'canceled',
        },
        {
          text: this.localStorage.translations.pages.projects_status.status['v-ozhidanii'] || '',
          value: 'pending',
        },
        {
          text: this.localStorage.translations.pages.projects_status.status['v-rabote'] || '',
          value: 'in_progress',
        },
        {
          text: this.localStorage.translations.pages.projects_status.status['zavershen'] || '',
          value: 'done',
        },
      ]
    },
  },
  watch: {
    filter() {
      this.downloadPageData()
    },
    workClientProjectPeriods() {
      this.formatDataGantt()
    },
    employeesShow() {
      this.formatDataGantt()
    },
    periodsShow() {
      this.formatDataGantt()
    },
  },
  created() {
    this.downloadPageData()
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectPeriods']),
    downloadPageData() {
      this.onWorkClientProjectPeriods({ statusFilter: this.filter })
    },
    formatDataGantt(obj) {
      this.tasks.data = []
      for (let key in this.workClientProjectPeriods.data) {
        var project = this.workClientProjectPeriods.data[key]
        if (project.status && project.start_date && project.end_date) {
          let projectId = 'project_' + project.id
          let projectObj = {}

          projectObj['id'] = projectId
          projectObj['text'] = project.name
          projectObj['start_date'] = this.$formatDate(project.start_date)
          projectObj['end_date'] = this.$formatDate(project.end_date)
          projectObj['color'] =
            project.status === 'creating'
              ? '#F2C94C'
              : project.status === 'intro'
              ? '#F2C94C'
              : project.status === 'bidding'
              ? '#F2994A'
              : project.status === 'canceled'
              ? '#EB5757'
              : project.status === 'pending'
              ? '#333333'
              : project.status === 'in_progress'
              ? '#2D9CDB'
              : project.status === 'done'
              ? '#27AE60'
              : '#000000'
          projectObj['type'] = 'object'
          projectObj['status'] = project.status
          // projectObj['plan'] = { size: null, time: null }
          // projectObj['fact'] = { size: null, time: null }
          // projectObj['days'] = {}
          this.tasks.data.push(projectObj)

          for (let key in project.project_work_types) {
            var workType = project.project_work_types[key]
            for (let key in workType.periods) {
              var period = workType.periods[key]
              let periodId = this.periodsShow
                ? projectId + '-work_type_' + workType.work_type.id + '-period_' + period.id
                : projectId
              let periodObj = {}
              periodObj.id = periodId
              periodObj.text = workType.work_type.name
              periodObj.start_date = this.$formatDate(period.start_date)
              periodObj.end_date = this.$formatDate(period.end_date)
              periodObj.color = '#F2994A'
              periodObj.type = 'period'
              periodObj.parent = projectId
              if (this.periodsShow) {
                this.tasks.data.push(periodObj)
              }
              for (let key in period.employees) {
                let employee = period.employees[key]
                let employeeObj = {}
                employeeObj.id = this.periodsShow
                  ? periodId + '-employee_' + employee.id
                  : periodId + '-period_' + period.id + '-employee_' + employee.id
                employeeObj.text = employee.user.first_name + ' ' + employee.user.last_name
                employeeObj.start_date = this.$formatDate(period.start_date)
                employeeObj.end_date = this.$formatDate(period.end_date)
                employeeObj.color = '#0D9D2C'
                employeeObj.type = 'employee'
                employeeObj.parent = periodId
                employeeObj.last_name = employee.user.last_name
                employeeObj.first_name = employee.user.first_name
                employeeObj.photo = employee.user.photo
                employeeObj.work_type_name = workType.work_type.name
                if (this.employeesShow) {
                  this.tasks.data.push(employeeObj)
                }
              }
            }
          }
        }
      }
      this.$refs.gantt.updateGantt()
    },
  },
}
</script>

<style lang="scss" scoped>
:deep().icon {
  margin-right: 10px;
  &--works {
    path {
      fill: #27ae60 !important;
    }
  }
  &--employee {
    path {
      fill: #277faf !important;
    }
  }
}
.wrapper_table_work {
  height: 100%;
  display: grid;
  grid-template-rows: max-content 1fr;
  .checkbox_grid {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }
  .pdf_wrapper {
    margin: 0 auto;
    padding: 0px 60px;
    width: 100%;
  }

  :deep().v-input {
    width: max-content;
    &--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }
  }
}
</style>
